import { Button, ButtonProps, Space } from 'antd';
import { useTranslation } from 'react-i18next';

import cx from '@vindr/utils/helpers/cx';
import Assign from './components/Assign';
import Delete from './components/Delete';
import Edit from './components/Edit';
import Options from './components/Options';
import { ReactNode } from 'react';

export interface ActionProps extends ButtonProps {
  children?: ReactNode;
  title?: string;
  className?: string;
  disabled?: boolean;
}

const ActionIcon = ({ children }: { children: React.ReactNode }) => {
  return (
    <Space size="small" className="actions">
      {children}
    </Space>
  );
};

export const WrapperAction = ({ children, title, className, disabled, ...props }: ActionProps) => {
  const { t } = useTranslation('Vindoc');

  return (
    <Button
      title={t(title)}
      style={{ borderColor: 'rgba(255, 255, 255, 0.25)' }}
      className={cx(
        'flex items-center justify-center text-black dark:text-white',
        {
          'bg-[#ffffff14] fill-[#ffffff40] text-[#ffffff40]': disabled,
        },
        className
      )}
      size="small"
      ghost
      disabled={disabled}
      {...props}
    >
      {children}
    </Button>
  );
};

ActionIcon.Assign = Assign;
ActionIcon.Edit = Edit;
ActionIcon.Delete = Delete;
ActionIcon.Options = Options;

export default ActionIcon;
